import router from "@/router.js"
function back() {
    router.go(-1);
}

export default back;